<template>
    <div>
        <div v-if="viewMode === 'tabela'">
            <div class="mb-3">
                <b-row>
                    <b-col cols="12" md="3">
                        <b-input-group>
                            <b-form-input
                                v-model="termoBusca"
                                placeholder="Buscar"
                                style="padding-left: 12px; padding-right: 12px;"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button variant="primary">
                                    <i class="fa fa-search"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                </b-row>
            </div>
            <div>
                <memoria-calculo-tabela
                    ref="tabela"
                    :modoEdicao="modoEdicao"
                    :termoBusca="termoBusca"
                    :boletimMedicao="boletimMedicao"
                    :boletimEditavel="boletimEditavel"
                    :exibir-coluna-aprovado="isFiscalAprovandoFiscalObras"
                    :itens-aprovados="itensAprovadosRascunho"
                    @itens-aprovados-alterados="itensAprovadosRascunho = $event"
                    @itens-alterados="handleItensAlterados"
                    @recarregar-dados="$emit('recarregar-dados')"
                ></memoria-calculo-tabela>
            </div>
            <div>
                <memoria-calculo-acoes :modo-edicao="modoEdicao" :salvando-dados="salvandoDados" :view-mode="'tabela'" :is-fornecedor="isFornecedor" :boletim-editavel="boletimEditavel" :tem-item-editavel="temItemEditavel" :pode-gerar-pdf-para-assinatura="podeGerarPdfParaAssinatura" :texto-botao-gerar-pdf="textoBotaoGerarPdfAssinatura" :fluxo-interno="fluxoInternoAssinaturaSuape" @toggle-edicao="toggleEdicao" @gerar-pdf="gerarPdf" :exibir-botao-salvar-aprovacao-itens="isFiscalAprovandoFiscalObras" :salvando-aprovacao-itens="salvandoAprovacaoItens" @salvar-aprovacao-itens="salvarAprovacaoItens" @voltar="handleVoltar"></memoria-calculo-acoes>
            </div>
        </div>
        <div v-else-if="viewMode === 'GerarPdf'">
            <memoria-calculo-gerar-pdf
                ref="memoriaCalculoGerarPdf"
                :itens="boletimMedicao.itens"
                :boletimMedicao="boletimMedicao"
                :contrato="contrato"
                :valorTotalTodosBoletins="valorTotalTodosBoletins"
                :fornecedorLogoUrl="fornecedorLogoUrl"
            ></memoria-calculo-gerar-pdf>
            <memoria-calculo-acoes :view-mode="'GerarPdf'" :modo-edicao="modoEdicao" :is-fornecedor="isFornecedor" :boletim-editavel="boletimEditavel" @toggle-concluir="concluir" @download-pdf="downloadPdf" @voltar="handleVoltar"></memoria-calculo-acoes>
        </div>
        <div v-else-if="viewMode === 'Concluir'">
            <memoria-calculo-concluir
                ref="memoriaCalculoConcluir"
                :contrato-id="boletimMedicao.contratoId || contrato.contratoId"
                :boletim-medicao-id="boletimMedicao.boletimMedicaoId"
                :documento-boletim-medicao-id="documentoMemoriaCalculoAssinada?.documentoBoletimMedicaoId"
                :nome-arquivo-existente="nomeAnexoMemoriaCalculoAssinado"
                :tipo-anexo="tipoAnexoMemoriaCalculoAssinadaAtual"
                @arquivo-enviado-sucesso="handleArquivoEnviadoSucesso"
            ></memoria-calculo-concluir>
            <memoria-calculo-acoes :view-mode="'Concluir'" :modo-edicao="modoEdicao" @voltar="handleVoltar"></memoria-calculo-acoes>
        </div>


    </div>
</template>

<script>
import MemoriaCalculoTabela from './MemoriaCalculoTabela.vue'
import MemoriaCalculoAcoes from './MemoriaCalculoAcoesBtn.vue'
import MemoriaCalculoGerarPdf from './MemoriaCalculoGerarPdf.vue'
import MemoriaCalculoConcluir from './MemoriaCalculoConcluir.vue'
import MemoriaCalculoServicos from './MemoriaCalculoServicos'
import BoletimMedicaoServicos from '../../../fornecedor/contratos/boletinsMedicoes/BoletimMedicaoServicos'
import { statusItemBoletimMedicaoEnum, statusBoletimMedicaoEnum } from '../../../fornecedor/contratos/boletinsMedicoes/BoletimMedicao'
import { tiposAnexoEnum } from '../../../fornecedor/contratos/boletinsMedicoes/tiposAnexo'

export default {
    name: 'MemoriaCalculoTab',
    components: {
        MemoriaCalculoTabela,
        MemoriaCalculoAcoes,
        MemoriaCalculoGerarPdf,
        MemoriaCalculoConcluir
    },
    props: {
        boletimMedicao: {
            type: Object,
            default: () => {}
        },
        isFornecedor: {
            type: Boolean,
            default: true
        },
        boletimEditavel: {
            type: Boolean,
            default: false
        },
        contrato: {
            type: Object,
            required: true
        },
        valorTotalTodosBoletins: {
            type: Number,
            required: false
        },
        fornecedorLogoUrl: {
            type: String,
            default: null
        },
        exibirAprovacaoItens: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            //TODO: ESSE MODO EDICAO (TAMBÉM) SÓ PODE RETORNAR TRUE SE O BOLETIM NÃO TIVER SIDO ENVIADO PRA APROVACAO AINDA
            modoEdicao: this.isFornecedor && this.boletimEditavel,
            termoBusca: '',
            viewMode: 'tabela',
            salvandoDados: false,
            salvandoAprovacaoItens: false,
            itensAprovadosLocal: [],
            itensAprovadosRascunho: []
        };
    },
    watch: {
        boletimEditavel(novoValor) {
            if (!novoValor) {
                this.modoEdicao = false;
            }
        },
        isFornecedor(novoValor) {
            if (!novoValor) {
                this.modoEdicao = false;
            }
        },
        boletimMedicao: {
            immediate: true,
            deep: true,
            handler() {
                const itensAprovadosIniciais = this.obterItensAprovadosPeloStatus();
                this.itensAprovadosLocal = itensAprovadosIniciais;
                this.itensAprovadosRascunho = [...itensAprovadosIniciais];
                this.$emit('update:itensAprovados', itensAprovadosIniciais);
            }
        }
    },
    computed: {
        isFiscalAprovandoFiscalObras() {
            return this.exibirAprovacaoItens;
        },
        temItemEditavel() {
            const possuiValorUnitario = item => {
                const valorUnitario = parseFloat(item?.valorUnitario);
                return !isNaN(valorUnitario) && valorUnitario !== 0;
            };

            const possuiItemEditavel = (itens = []) => {
                return itens.some(item => {
                    if (item?.status !== statusItemBoletimMedicaoEnum.AprovadoFiscalObras && possuiValorUnitario(item)) {
                        return true;
                    }

                    if (Array.isArray(item?.subitens) && item.subitens.length > 0) {
                        return possuiItemEditavel(item.subitens);
                    }

                    return false;
                });
            };

            return possuiItemEditavel(this.boletimMedicao?.itens || []);
        },
        podeGerarPdfParaAssinatura() {
            return (this.isFornecedor
                && this.boletimMedicao?.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor)
                || (this.isFornecedor
                    && this.boletimMedicao?.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor
                    && this.boletimMedicao?.memoriaCalculoEditavel)
                || (this.$temAcessoView('FISCAL-TERCEIRO')
                    && this.boletimMedicao?.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalTerceiro)
                || ((this.contrato?.usuarioEhCadastrador || this.contrato?.usuarioEhOrdenador)
                    && this.boletimMedicao?.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalObras);
        },
        fluxoInternoAssinaturaSuape() {
            return !this.isFornecedor
                && (this.contrato?.usuarioEhCadastrador || this.contrato?.usuarioEhOrdenador)
                && this.boletimMedicao?.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalObras;
        },
        textoBotaoGerarPdfAssinatura() {
            return this.fluxoInternoAssinaturaSuape
                ? 'Enviar PDF Assinado'
                : 'Gerar PDF para Assinatura';
        },
        tipoAnexoMemoriaCalculoAssinadaAtual() {
            if (this.isFornecedor && this.boletimMedicao?.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor) {
                return tiposAnexoEnum.MemoriaCalculoAssinadaPeloFornecedor;
            }
            const tipoPorStatus = {
                [statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor]: tiposAnexoEnum.MemoriaCalculoAssinadaPeloFornecedor,
                [statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalTerceiro]: tiposAnexoEnum.MemoriaCalculoAssinadaPeloFiscalTerceiro,
                [statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalObras]: tiposAnexoEnum.MemoriaCalculoAssinadaPeloFiscalObras
            };

            return tipoPorStatus[this.boletimMedicao?.status] || null;
        },
        nomeAnexoMemoriaCalculoAssinado() {
            const tipo = this.tipoAnexoMemoriaCalculoAssinadaAtual;
            if (!tipo) return null;
            const anexo = (this.boletimMedicao?.anexos || []).find(a => a.tipoAnexoBoletimMedicao === tipo);
            return anexo ? (anexo.nome || 'Arquivo já enviado') : null;
        },
        documentoMemoriaCalculoAssinada() {
            const tipo = this.tipoAnexoMemoriaCalculoAssinadaAtual;
            if (!tipo) return null;
            return (this.boletimMedicao?.anexos || []).find(a => a.tipoAnexoBoletimMedicao === tipo) || null;
        },
    },
    methods: {
        obterItensAprovadosPeloStatus() {
            const itensAprovados = [];

            const percorrerItens = (itens = []) => {
                itens.forEach(item => {
                    const valorUnitario = parseFloat(item?.valorUnitario);
                    const itemAprovavel = !isNaN(valorUnitario) && valorUnitario !== 0;

                    if (itemAprovavel && item?.status === statusItemBoletimMedicaoEnum.AprovadoFiscalObras) {
                        itensAprovados.push(item.itemBoletimMedicaoId);
                    }

                    if (Array.isArray(item?.subitens) && item.subitens.length > 0) {
                        percorrerItens(item.subitens);
                    }
                });
            };

            percorrerItens(this.boletimMedicao?.itens || []);
            return itensAprovados;
        },
        async salvarAprovacaoItens() {
            const idsAprovados = new Set(this.itensAprovadosRascunho || []);

            const itensAprovaveis = [];
            const percorrerItens = (itens = []) => {
                itens.forEach(item => {
                    const valorUnitario = parseFloat(item?.valorUnitario);
                    const itemAprovavel = !isNaN(valorUnitario) && valorUnitario !== 0;

                    if (itemAprovavel) {
                        itensAprovaveis.push(item);
                    }

                    if (Array.isArray(item?.subitens) && item.subitens.length > 0) {
                        percorrerItens(item.subitens);
                    }
                });
            };

            percorrerItens(this.boletimMedicao?.itens || []);

            const contratoId = this.boletimMedicao.contratoId || this.contrato?.contratoId;
            const boletimMedicaoIdPadrao = this.boletimMedicao.boletimMedicaoId;

            const itensParaAprovar = itensAprovaveis.filter(item =>
                idsAprovados.has(item.itemBoletimMedicaoId)
                && item.status !== statusItemBoletimMedicaoEnum.AprovadoFiscalObras
            );

            if (itensParaAprovar.length === 0) {
                this.itensAprovadosLocal = [...this.itensAprovadosRascunho];
                this.$emit('update:itensAprovados', this.itensAprovadosLocal);

                if (this.$toast) {
                    this.$toast.info('Nenhuma alteração de aprovação para salvar.', 'Informação', {
                        position: 'topRight',
                        timeout: 3000
                    });
                }
                return;
            }

            this.salvandoAprovacaoItens = true;

            try {
                await Promise.all(
                    itensParaAprovar.map(item =>
                        BoletimMedicaoServicos.aprovarItemBoletimMedicaoPeloFiscalObras(
                            contratoId,
                            item.boletimMedicaoId || boletimMedicaoIdPadrao,
                            item.itemBoletimMedicaoId
                        )
                    )
                );

                this.itensAprovadosLocal = [...this.itensAprovadosRascunho];
                this.$emit('update:itensAprovados', this.itensAprovadosLocal);

                if (this.$toast) {
                    this.$toast.success('Aprovação dos itens salva com sucesso!', 'Sucesso', {
                        position: 'topRight',
                        timeout: 4000
                    });
                }

                this.$emit('recarregar-dados');
            } catch (error) {
                const mensagemErroApi =
                    error?.response?.data?.errors?.join?.('; ')
                    || error?.response?.data?.message
                    || error?.message
                    || 'Erro ao salvar aprovação dos itens.';

                if (this.$toast) {
                    this.$toast.error(mensagemErroApi, 'Erro', {
                        position: 'topRight',
                        timeout: 5000
                    });
                }
            } finally {
                this.salvandoAprovacaoItens = false;
            }
        },
        async toggleEdicao() {
            if (!this.isFornecedor || !this.boletimEditavel) {
                return;
            }

            if (this.modoEdicao) {
                await this.salvarAlteracoesAPI();
            }

            this.modoEdicao = !this.modoEdicao;
        },

        async salvarAlteracoesAPI() {
            const isValido = this.$refs.tabela?.validarAntesDeSalvar();
            if (!isValido) {
                return;
            }

            const itensModificados = this.$refs.tabela?.getItensModificados() || [];

            if (itensModificados.length === 0) {
                return;
            }

            this.salvandoDados = true;

            try {
                const promessas = itensModificados.map(item => {
                    const contratoId = this.boletimMedicao.contratoId;
                    const boletimMedicaoId = item.boletimMedicaoId;
                    const itemBoletimMedicaoId = item.itemBoletimMedicaoId;
                    const dados = {
                        quantidade: item.quantidade,
                        responsavel: this.$store.getters.usuario.nome
                    };

                    return MemoriaCalculoServicos.atualizarItemBoletimMedicao(
                        contratoId,
                        boletimMedicaoId,
                        itemBoletimMedicaoId,
                        dados
                    );
                });

                await Promise.all(promessas);

                this.$refs.tabela?.limparItensModificados();

                if (this.$toast) {
                    this.$toast.success('Dados salvos com sucesso!', 'Sucesso', {
                        position: 'topRight',
                        timeout: 5000
                    });
                }

                this.$emit('recarregar-dados');
            } catch (error) {
                if (this.$toast) {
                    this.$toast.error('Erro ao salvar, tente novamente', 'Erro', {
                        position: 'topRight',
                        timeout: 5000
                    });
                }
                console.error('Erro ao salvar alterações:', error);
            } finally {
                this.salvandoDados = false;
            }
        },
        handleItensAlterados() {
            console.log('Itens foram alterados:', this.boletimMedicao.itens);
        },
        salvarAlteracoes(dados) {
            console.log('Salvando alterações:', dados);
            this.modoEdicao = false;
        },
        gerarPdf() {
            if (!this.podeGerarPdfParaAssinatura) {
                return;
            }

            if (this.fluxoInternoAssinaturaSuape) {
                this.viewMode = 'Concluir';
                return;
            }

            if (this.nomeAnexoMemoriaCalculoAssinado) {
                this.viewMode = 'Concluir';
                return;
            }

            this.viewMode = 'GerarPdf';
        },
        concluir() {
            this.viewMode = 'Concluir';
        },
        downloadPdf() {
            this.$refs.memoriaCalculoGerarPdf?.baixarPdf();
        },
        handleVoltar() {
            if (this.viewMode === 'tabela') {
                this.$router.go(-1);
            }
            else if (this.viewMode === 'Concluir') {
                this.viewMode = this.fluxoInternoAssinaturaSuape ? 'tabela' : 'GerarPdf';
            }
            else if (this.viewMode === 'GerarPdf') {
                this.viewMode = 'tabela';
            }
        },
        handleArquivoEnviadoSucesso() {
            this.viewMode = 'Concluir';
            this.$emit('recarregar-dados');
        }
    },
    mounted() {
        if (this.podeGerarPdfParaAssinatura && this.nomeAnexoMemoriaCalculoAssinado) {
            this.viewMode = 'Concluir';
        }
    },
};
</script>
